import { Fragment } from "react";
import { useTranslation } from "@crehana/i18n";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Checkbox } from "@crehana/ui";
import { clsx } from "clsx";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var rulesForRHFControllerComponent = function rulesForRHFControllerComponent(t) {
  return {
    required: {
      value: true,
      message: t('AUTH_VALIDATION_LEGALS_REQUIRED', 'Debes aceptar los Términos, Condiciones y Políticas para continuar.')
    }
  };
};
export var LegalErrorMessage = function LegalErrorMessage(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_jsx("span", {
    className: "block mt-4 font-legals text-red-main",
    role: "alert",
    children: message
  });
};
var LegalCheckbox = function LegalCheckbox(_ref2) {
  var onChange = _ref2.onChange,
    value = _ref2.value,
    _ref2$isDark = _ref2.isDark,
    isDark = _ref2$isDark === void 0 ? false : _ref2$isDark,
    dataTestId = _ref2.dataTestId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Checkbox, {
    small: true,
    isDark: isDark,
    "data-testid": dataTestId,
    label: /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: clsx({
          'text-white': isDark,
          'text-gray-dark': !isDark
        }),
        children: t('LEGALS_TEXT_1', 'Acepto los ')
      }), /*#__PURE__*/_jsx("a", {
        href: "/legal/",
        target: "_blank",
        className: "font-legals text-gray-dark",
        style: {
          textDecoration: 'none'
        },
        children: t('LEGALS_TEXT_2', 'Términos, Condiciones y Políticas de Crehana.')
      })]
    }),
    onChange: function (_onChange) {
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange.toString();
      };
      return onChange;
    }(function (event) {
      var checked = event.target.checked;
      onChange(!checked);
    }),
    checked: value
  });
};
export default LegalCheckbox;